import type { ReactElement } from 'react';
import { Navigate, type RouteObject } from 'react-router';

/**
 * A record page's tabs as routes, `<recordPath>/<tab>`, with the bare `<recordPath>` redirecting to the first tab.
 * A link can then land on the tab it means (the compliance overview opens Documents), and a reload stays on it.
 * This is the section-tab rule (CLAUDE.md → Tabs are routes) applied one level down.
 */
export function recordTabRoutes<T extends string>(recordPath: string, tabs: readonly [T, ...T[]], render: (tab: T) => ReactElement): RouteObject[] {
  return [{ path: recordPath, element: <Navigate to={tabs[0]} replace /> }, ...tabs.map((tab) => ({ path: `${recordPath}/${tab}`, element: render(tab) }))];
}
